// extracted by mini-css-extract-plugin
export default {"productDescription":"caa-z","featuredDescription":"daa-z","description":"eaa-z","more":"faa-z","descriptionSku":"gaa-z"};